import type { SkinViews } from '!/skin'
import { BATCH_TIMEOUT } from './index.h'
import { SkinBatchLoader } from './loader'

const loader = new SkinBatchLoader<SkinViews>('/api/era/skin', BATCH_TIMEOUT)

export function skin(path: string): Promise<SkinViews> {
  return loader.get(path)
}
